import React, { ComponentProps } from 'react';

import PropTypes from 'prop-types';

import { BasicButton } from '@adsk/alloy-react-button';
import { XIcon } from '@adsk/alloy-react-icon';
import { useLocale } from '@adsk/alloy-react-locale';
import theme from '@adsk/alloy-react-theme';
import Tooltip from '@adsk/alloy-react-tooltip';

type Props = Omit<ComponentProps<typeof BasicButton>, 'onClick'> & {
  onClick: () => void;
  tooltipProps?: Partial<ComponentProps<typeof Tooltip>>;
};

const BlockRemoveButton = React.forwardRef<HTMLButtonElement, Props>(
  ({ className, style, onClick, tooltipProps, ...props }, ref) => {
    const { T } = useLocale(({ locale }) => require(`./i18n/${locale}.json`));

    return (
      <Tooltip {...tooltipProps} content={T.translate('REMOVE')}>
        <BasicButton
          ref={ref}
          className={className}
          style={[
            {
              color: theme.colors.red700,
              border: `1px solid ${theme.colors.charcoal400}`,
              borderRadius: 2,
              padding: 3,
              width: 24,
              height: 24,
            },
            style,
          ]}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onClick();
          }}
          {...props}
        >
          <XIcon size={16} />
        </BasicButton>
      </Tooltip>
    );
  },
);

BlockRemoveButton.displayName = 'BlockRemoveButton';

BlockRemoveButton.propTypes = {
  ...BasicButton.propTypes,
  /** handle onclick event for the button */
  onClick: PropTypes.func.isRequired,
};

export default BlockRemoveButton;
